import axios from 'axios';

const api = axios.create({
    baseURL: 'https://base-auction.com',
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('authToken');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const loginService = async (email, password) => {
    const res = await api.post('/api/calc/auth/login', { email, password });
    const token = res.data?.token;

    if (token) {
        localStorage.setItem('authToken', token);
    }

    return res.data;
};

export const me = async () => {
    const res = await api.post('/api/calc/me');
    return res.data;
};

export const getAuctionService = async () => {
    const res = await api.get('/api/calc/auctions');
    return res.data;
}

export const getPortsService = async () => {
    const res = await api.get('/api/calc/ports-usa');
    return res.data;
}


export const checkTitleService = async (title) => {
    const res = await api.post('/api/calc/title-check', {
        title
    })
    return res.data;
}


export const calcShippingService = async (auction_id, city_id) => {
    const res = await api.post(`/api/calc/price/${auction_id}/${city_id}`, {})
    return res.data;
}

export const getCitiesService = async (auction_id) => {
    const res = await api.get(`/api/calc/locations/${auction_id}`)
    return res.data;
}
